import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import QRScan from "../../qrScan/components/QRScan";
import { useParams } from "react-router-dom";
import { settingCamaraAndStockThroughWizard } from "../api/camaraSetupWizard.api";

// --- Constantes de Coordenadas de Referencia (Obelisco) ---
// Este es el valor por defecto que indica que el usuario NO ha movido el pin.
const DEFAULT_COORDS = { lat: -34.6037, lng: -58.3816 };
// --------------------------------------------------------

// Definición de tipos para la cámara
interface CamaraState {
    Name: string;
    identifier: string;
    orientation: string;
    coordinates: { lat: number; lng: number };
    visible: boolean;
    featured: boolean; 
    camaraUID: string;
    customerId: string;
    active: boolean;
    status: string;
    
}


const CamaraSetupWizard = () => {

    const [showScanner, setShowScanner] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [success, setSuccess] = useState<boolean>(false);
    const [isSaved, setIsSaved] = useState<boolean>(false);

    const params = useParams();
    const customerIdFromParams = params.customerId || "";
    const identifierFromParams = params.identifier || "";

    // Estado inicial de la cámara, usando DEFAULT_COORDS
    const [camara, setCamara] = useState<CamaraState>({
        Name: "",
        identifier: "",
        orientation: "",
        coordinates: DEFAULT_COORDS, // Usar la constante
        visible: false,
        featured: false,
        camaraUID: "", // Debe ser llenado por el scan
        customerId: "",
        active: true,
        status: "Creado",
    });

    
    const isFormComplete = (): boolean => {
        return (
            camara.Name.trim() !== "" &&
            camara.orientation !== "" &&
            camara.camaraUID !== ""
        );
    };


    const handleScanSuccess = (camaraUID: string) => { 
    

    
    setCamara(prev => ({
        ...prev,
        camaraUID: camaraUID, 
    }));
    
    toast.success("Escaneo exitoso. UID de cámara actualizado.");
    
    // Solo ahora cerramos el escáner y volvemos al formulario
    setShowScanner(false); 
};

    const handleChanges = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        const target = e.target as HTMLInputElement;
        let newValue: string | number | boolean;

        if (target.type === "checkbox") {
            newValue = target.checked;
        } else if (name === "displayOrder") {
            const parsedValue = parseInt(value, 10);
            newValue = isNaN(parsedValue) ? 0 : parsedValue;
        } else {
            newValue = value;
        }

        setCamara((prev) => ({ 
            ...prev, 
            [name]: newValue 
        }));
    };

    const navigate = useNavigate(); 
  
    const onClose = () => {
        navigate(`/customerDashboard/${customerIdFromParams}`); // Navega al dashboard o página principal
    }
    
   
    const saveCamara = async () => {
        setIsLoading(true);

        const data = {...camara, identifier: identifierFromParams, customerId: customerIdFromParams };

        try {
            const response = await settingCamaraAndStockThroughWizard(identifierFromParams, data);
            console.log("Datos de la cámara a guardar:", data);
            //toast.success(`Cámara '${camara.Name}' configurada y guardada exitosamente!`);
            //setSuccess(true);
            setIsSaved(true);
            toast.success(`Cámara '${camara.Name}' configurada y guardada exitosamente!`)
            setTimeout(() => {
                //onClose();
                //setSuccess(false)}, 10000);
                onClose();}, 3000);
             // Cerrar el wizard y navegar al inicio/dashboard
            
        } catch (error) {
            console.error("Error al guardar la cámara:", error);
            toast.error("Error al guardar la cámara. Intente de nuevo.");
        } finally {
            setIsLoading(false);
        }
    }
    
    
    const handleSubmit = () => {
        if (isFormComplete()) {
            saveCamara(); 
        } else if (camara.camaraUID === "") {

            openScanner();
        } else {
            toast.warn("Por favor, complete todos los campos requeridos (Nombre, Orientación, UID).");
        }
    }

    const openScanner = () => {
        setShowScanner(true);
    }

    
    const formIsReady = isFormComplete();
    
    const buttonText = isSaved ? "Terminado" : formIsReady ? "Finalizar" : 
                        camara.camaraUID === "" ? "Escanear QR" : "Continuar";
                       
    const buttonClass = isSaved ? "bg-gray-400 cursor-not-allowed" : formIsReady ? 
         "bg-green-600 hover:bg-green-700" : 
         "bg-blue-600 hover:bg-blue-700";


    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 overflow-y-auto"
            onClick={(e) => e.target === e.currentTarget && onClose()}
        >
            <div className="relative bg-white rounded-xl w-full max-w-5xl mt-16 mb-8 shadow-lg flex flex-col">
                {/* Header*/}
                <div className="flex justify-between items-center border-b p-6">
                    <h2 className="text-2xl font-bold">
                        Bienvenido al Asistente de Configuración de Cámara
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 text-xl"
                    >
                        ✕
                    </button>
                </div>

{!success ? (
    <>

{!showScanner ? (
                /* Body*/
                <div className="p-6 space-y-8 overflow-y-auto max-h-[75vh]">
                    <p className="text-gray-600">Lo guiaremos paso a paso:</p>
            
                    {/* Campos de Información Básica (2 columnas)*/}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <h3 className="col-span-full text-lg font-semibold text-blue-600 border-b pb-2">Información de la Cámara</h3>
                        
                        {/* Nombre*/}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Nombre de la cámara
                            </label>
                            <input
                                type="text"
                                value={camara.Name}
                                name="Name"
                                onChange={handleChanges}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>

                        {/* SIM
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                SIM *
                            </label>
                            <input
                                value={camara.simNumber}
                                name="simNumber"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const newValue = value.replace(/[^0-9+]/g, ''); // Permite '+' y números
                                    e.target.value = newValue;
                                    handleChanges(e);
                                }}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>
                        */}

                        {/* Orientación */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Orientación *
                            </label>
                            <select
                                value={camara.orientation}
                                name="orientation"
                                onChange={handleChanges}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="" disabled>Seleccione una opción</option>
                                <option value="horizontal">Horizontal</option>
                                <option value="vertical">Vertical</option>
                            </select>
                        </div>
                        
                        {/* UID de Cámara (READONLY) */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Escanea el QR debajo de tu cámara tocando continuar
                            </label>
                            <input
                                type="text"
                                value={camara.camaraUID}
                                name="camaraUID"
                                readOnly
                                disabled={!!camara.camaraUID}
                                className={`w-full border rounded-lg px-3 py-2 ${camara.camaraUID ? 'bg-gray-100 border-gray-300' : 'border-red-400 bg-red-50'}`}
                            />
                            {camara.camaraUID ? (
                                <p className="mt-1 text-sm text-green-600">UID escaneado correctamente.</p>
                            ) : (
                                <p className="mt-1 text-sm text-red-600">Requerido: Escanee el código QR para obtener el UID.</p>
                            )}
                        </div>
                        
                    </div>
                </div>

) : ( <QRScan
        onScanSuccess={handleScanSuccess} 
        />
    )   }
                {/* Footer (Botón condicional)*/}
                <div className="flex justify-end gap-3 border-t p-4 bg-gray-50 rounded-b-xl">
                    <button
                        onClick={onClose}
                        className="px-6 py-2 bg-gray-300 text-gray-800 font-medium rounded-lg hover:bg-gray-400 transition duration-150"
                        disabled={isLoading || isSaved} // Deshabilitar si está cargando
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleSubmit}
                        className={`px-6 py-2 text-white font-medium rounded-lg transition duration-150 ${buttonClass}`}
                        disabled={isLoading} // Deshabilitar si está cargando
                    >
                        {isLoading ? (
                            <div className="flex items-center">
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Guardando...
                            </div>
                        ) : (
                            buttonText
                        )}
                    </button>
                </div>
    </>
                    ): (
                        <div className="flex flex-col items-center justify-center p-10 h-96"> {/* Añade padding y una altura mínima */}
    {/* Icono de Éxito (Grande y Vibrante) */}
    <div className="p-4 bg-green-100 rounded-full mb-6">
        <svg 
            className="w-16 h-16 text-green-600" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth="2" 
                d="M5 13l4 4L19 7"
            ></path>
        </svg>
    </div>

    {/* Mensaje Principal */}
    <p className="mt-4 text-3xl text-center text-green-700 font-extrabold mb-2">
        ¡Configuración Exitosa!
    </p>

    {/* Mensaje Secundario */}
    <p className="text-lg text-center text-gray-700">
        La cámara <strong>{camara.Name}</strong> ha sido configurada y guardada.
    </p>

    {/* CTA (Llamada a la Acción) */}
    <div className="mt-8 text-center">
        <p className="text-md text-gray-500 mb-4">
            Podes continuar gestionando tu cámara en la plataforma:
        </p>
        <a 
            href="https://pro.lisual.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150"
        >
            Ir a pro.lisual.com
            {/* Opcional: Icono de flecha/enlace externo */}
            <svg className="ml-2 -mr-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
            </svg>
        </a>
    </div>

    {/* Botón para cerrar el modal */}
    <div className="mt-6">
        <button
            onClick={onClose}
            className="text-sm font-medium text-gray-500 hover:text-gray-900 transition duration-150"
        >
            Cerrar Asistente
        </button>
    </div>
</div>
                    )}
            </div>
        </div>
    );
};

export default CamaraSetupWizard;